import React, { Component } from "react";
import PropTypes from "prop-types";
import AndtDTextBoxWrapper from "swfrontend/MDM/MDMAntdWrappers/TextBoxWrapper";
import AntDSelectWrapper from "../../../../Components/CustomWrappers/AntDSelectWrapper";
import { PincodeValidator } from "../validators";

class GeneralDetails extends Component {
  render() {
    const {
      formRef,
      handleChange,
      countryData,
      statesData,
      pincodeLength,
      citiesData,
      isDisabled,
      is_AN13,
      isAN13Update,
      isOptional,
      isInEdit,
      isStaff,
      registrationFields,
      isRequired,
      optionalFields,
      req_op_fields,
      industriesData,
      is_gst_required,
      isAN22OrAN13,
    } = this.props;

    return (
      <div className="row form-box">
        <legend className="form-legend">General Details</legend>

        {isInEdit && !isStaff && (
          <div className="col-lg-6 col-md-12">
            <AndtDTextBoxWrapper
              decorator="crm_prospect_id"
              id="CRM Prospect ID"
              required={false}
              disabled={true}
              label="CRM Prospect ID"
              message="Enter CRM Prospect ID"
              placeholder="Enter CRM Prospect ID"
              validators=""
              maxlength={35}
              formRef={formRef}
            />
          </div>
        )}

        {!isAN22OrAN13 && (
          <div className="col-lg-6 col-md-12">
            <AntDSelectWrapper
              decorator="customer_type"
              id="customer_type"
              required={
                "customer_type" in req_op_fields["O"]
                  ? false
                  : "customer_type" in optionalFields
                  ? false
                  : isRequired
              }
              disabled={
                "customer_type" in req_op_fields["S"] ? true : isDisabled
              }
              label="Customer Type"
              message="Enter Customer Type"
              placeholder="Select Customer Type"
              app="masters"
              entity="customertype"
              validators=""
              options={[]}
              allowClear={true}
              primary_key_field="id"
              formRef={formRef}
            />
          </div>
        )}

        <div className="col-lg-6 col-md-12">
          <AntDSelectWrapper
            decorator="title"
            id="Title"
            required={
              "title" in req_op_fields["O"]
                ? false
                : "title" in optionalFields
                ? false
                : isRequired
            }
            disabled={"title" in req_op_fields["S"] ? true : isDisabled}
            label="Title"
            message="Enter Title"
            placeholder="Select Title"
            app="masters"
            entity="title"
            validators=""
            options={[]}
            allowClear={true}
            primary_key_field="title_id"
            formRef={formRef}
          />
        </div>

        <div className="col-lg-6 col-md-12">
          <AndtDTextBoxWrapper
            decorator="customer_name"
            id="Company Name"
            required={true}
            disabled={"customer_name" in req_op_fields["S"] ? true : isDisabled}
            label="Company Name"
            message="Enter Company Name"
            placeholder="Enter Company Name"
            validators=""
            casetype="uppercase"
            maxlength={140}
            formRef={formRef}
          />
        </div>

        {!is_AN13 && (
          <div
            className="col-lg-6 col-md-12"
            hidden={"type_of_industry" in registrationFields}
          >
            <AntDSelectWrapper
              decorator="type_of_industry"
              id="Type Of Industry"
              required={
                isAN13Update
                  ? false
                  : "type_of_industry" in req_op_fields["O"]
                  ? false
                  : true
              }
              disabled={
                "type_of_industry" in req_op_fields["S"] ? true : isDisabled
              }
              label="Type Of Industry"
              message="Enter Type Of Industry"
              placeholder="Enter Type Of Industry"
              validators=""
              options={industriesData}
              primary_key_field="industry_type_id"
              onChange={handleChange}
              formRef={formRef}
            />
          </div>
        )}

        <div className="col-lg-6 col-md-12">
          <AndtDTextBoxWrapper
            decorator="address_line1"
            id="Address Line1"
            required={
              is_AN13
                ? true
                : "address_line1" in req_op_fields["O"]
                ? false
                : "address_line1" in optionalFields
                ? false
                : isRequired
            }
            disabled={"address_line1" in req_op_fields["S"] ? true : isDisabled}
            label="Address Line 1"
            message="Enter Address Line1"
            placeholder="Enter Address Line1"
            casetype="uppercase"
            validators=""
            maxlength={60}
            formRef={formRef}
          />
        </div>

        <div className="col-lg-6 col-md-12">
          <AndtDTextBoxWrapper
            decorator="address_line2"
            id="Address Line2"
            required={false}
            disabled={"address_line2" in req_op_fields["S"] ? true : isDisabled}
            label="Address Line 2"
            message="Enter Address Line2"
            placeholder="Enter Address Line2"
            casetype="uppercase"
            validators=""
            maxlength={40}
            formRef={formRef}
          />
        </div>

        <div className="col-lg-6 col-md-12">
          <AndtDTextBoxWrapper
            decorator="address_line3"
            id="Address Line3"
            required={false}
            disabled={"address_line3" in req_op_fields["S"] ? true : isDisabled}
            label="Address Line 3"
            message="Enter Address Line3"
            placeholder="Enter Address Line3"
            casetype="uppercase"
            validators=""
            maxlength={40}
            formRef={formRef}
          />
        </div>

        <div className="col-lg-6 col-md-12">
          <AntDSelectWrapper
            decorator="country"
            id="Country"
            required={"country" in req_op_fields["O"] ? false : true}
            disabled={
              "country" in req_op_fields["S"]
                ? true
                : isDisabled
            }
            label="Country"
            message="Enter Country"
            placeholder="Enter Country"
            onChange={handleChange}
            validators=""
            options={countryData}
            primary_key_field="country_id"
            formRef={formRef}
          />
        </div>

        <div className="col-lg-6 col-md-12">
          <AntDSelectWrapper
            decorator="state"
            id="state"
            required={
              is_AN13 && pincodeLength === 6
                ? true
                : "state" in req_op_fields["O"]
                ? false
                : !isOptional
            }
            disabled={"state" in req_op_fields["S"] ? true : isDisabled}
            label="State"
            message="Enter State"
            placeholder="Enter State"
            validators=""
            onChange={handleChange}
            options={statesData}
            primary_key_field="state_id"
            allowClear={true}
            formRef={formRef}
          />
        </div>

        <div className="col-lg-6 col-md-12">
          <AntDSelectWrapper
            decorator="city"
            id="City"
            required={
              is_AN13 ? true : "city" in req_op_fields["O"] ? false : true
            }
            disabled={"city" in req_op_fields["S"] ? true : isDisabled}
            label="City"
            message="Enter City"
            placeholder="Enter City"
            validators=""
            onChange={handleChange}
            options={citiesData}
            othertype={true}
            allowClear={true}
            primary_key_field="city_id"
            formRef={formRef}
          />
        </div>

        {/* // 10 means foreign country and 6 means india */}
        <div className="col-lg-6 col-md-12">
          <AndtDTextBoxWrapper
            decorator="pincode"
            id="Pin Code"
            required={"pincode" in req_op_fields["O"] ? false : !isOptional}
            disabled={"pincode" in req_op_fields["S"] ? true : isDisabled}
            label="Pin Code"
            message="Enter Pin Code"
            placeholder="Enter Pin Code"
            validators={
              pincodeLength === 6 ? [{ validator: PincodeValidator }] : ""
            }
            maxlength={pincodeLength}
            formRef={formRef}
          />
        </div>
      </div>
    );
  }
}

GeneralDetails.propTypes = {
  formRef: PropTypes.any,
};

export default GeneralDetails;
